/**@jsx jsx */
import { useRef } from 'react'
import { Input, IconButton, jsx } from 'theme-ui'
import SearchIcon from '~/assets/images/icons/search.svg'
const ArticleSearch = ({ setSearch }) => {
  const searchRef = useRef()
  return (
    <form
      onSubmit={e => {
        e.preventDefault()
        setSearch(searchRef.current?.value)
      }}
      sx={{
        position: 'relative',
        maxWidth: [null, null, '266px'],
        width: ['84%', '75%', 'auto'],
        m: ['0 auto', null, 0],
        border: '2px solid',
        borderRadius: ['8px', null, '10px'],
        ml: [null, null, 4],
        mb: ['30px', null, 0],
        height: ['50px', null, '46px'],
        overflow: 'hidden',
        borderColor: 'brilliantRose'
      }}
    >
      <Input
        ref={searchRef}
        onChange={e => (e.target.value === '' ? setSearch(null) : true)}
        placeholder="Search"
        sx={{
          color: 'brilliantRose',
          border: 'none',
          height: '100%',
          backgroundColor: 'white',
          fontSize: [2, 3],
          fontWeight: ['heading', 'body'],
          pl: '16.75px',
          '::placeholder': {
            opacity: 1,
            color: 'brilliantRose'
          }
        }}
      />
      <IconButton
        sx={{
          position: 'absolute',
          top: '50%',
          right: 0,
          transform: 'translateY(-50%)',
          cursor: 'pointer',
          padding: '16px 22px 14px 23px',
          width: 'auto',
          height: 'auto',
          backgroundColor: 'brilliantRose',
          border: 'none',
          borderRadius: 0
        }}
      >
        <SearchIcon />
      </IconButton>
    </form>
  )
}

export default ArticleSearch
